// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1sBtH","footer":"ModalUpdate_footer__2jWfV"};